import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Philosophy from "@/components/Philosophy";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import BookingForm from "@/components/BookingForm";
import Payment from "@/components/Payment";
import Footer from "@/components/Footer";
import ShareButton from "@/components/ShareButton";

export default function Home() {
  useEffect(() => {
    document.title = "Dr. Vrinda Jayaram · Happiness Coaching";
  }, []);

  return (
    <div className="min-h-screen bg-sunlit-ivory text-sunlit-ink" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Philosophy />
        <Services />
        <Testimonials />
        <Payment />
        <FAQ />
        <BookingForm />
      </main>
      <Footer />
      <ShareButton />
    </div>
  );
}
